import { useCallback } from 'react';
import { useGetStreamingTracksQuery } from '../../../../redux/api/fymAPI';

/** The tracks of the period, largest first (design d1). */
export function useStreamingTracks(accountId: number, days: number) {
  const { data, isLoading, error, refetch } = useGetStreamingTracksQuery({ accountId, days });
  const retry = useCallback(() => {
    refetch().catch(console.error);
  }, [refetch]);
  return { data, isLoading, error, retry };
}
